import React from 'react';

const ndaItems = [
  { title: 'Definitie vertrouwelijke informatie naar Nederlands recht', desc: 'Exacte omschrijving conform het Nederlandse recht inzake bedrijfsgeheimen (Wet bescherming bedrijfsgeheimen 2018)' },
  { title: 'Geheimhoudingsplicht voor ZZP\'ers', desc: 'Verplichtingen van de ontvanger om informatie niet te delen, afgestemd op de Nederlandse ZZP-praktijk' },
  { title: 'Uitzonderingen op de geheimhouding', desc: 'Situaties waarbij de geheimhoudingsplicht niet van toepassing is, zoals wettelijke verplichtingen of openbare informatie' },
  { title: 'Duur van de NDA in Nederland', desc: 'Hoe lang de geheimhoudingsplicht van kracht blijft — typisch 2 tot 5 jaar naar Nederlands recht' },
  { title: 'Boetebeding en schadevergoeding', desc: 'Financiële gevolgen bij schending, inclusief direct opeisbaar boetebeding conform het Nederlandse BW' },
  { title: 'Teruggave van vertrouwelijke informatie', desc: 'Verplichting om alle ontvangen documenten en kopieën terug te geven of te vernietigen na afloop van de opdracht' },
  { title: 'Toepasselijk Nederlands recht', desc: 'Nederlands recht als toepasselijk recht en bevoegde Nederlandse rechtbank bij geschillen' },
  { title: 'KvK-nummer en btw-nummer identificatie', desc: 'Correcte identificatie van partijen met KvK-nummer en btw-nummer voor Nederlandse ZZP\'ers en freelancers' },
];

const NdaNetherlandsContent = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Wat bevat een Nederlandse NDA voor ZZP'ers?</h2>
    <p className="text-gray-700 mb-6 leading-relaxed">
      Een professionele NDA voor Nederlandse ZZP'ers en freelancers bevat alle juridisch vereiste elementen conform het Nederlandse recht. Hieronder vind je de 8 kernonderdelen van een goede Nederlandse geheimhoudingsverklaring:
    </p>
    <ul className="space-y-3">
      {ndaItems?.map((item, i) => (
        <li key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
          <span className="flex-shrink-0 w-6 h-6 bg-[#FF8C00] rounded-full flex items-center justify-center mt-0.5">
            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </span>
          <div>
            <span className="font-semibold text-[#2F4E6F]">{item?.title}:</span>{' '}
            <span className="text-gray-600">{item?.desc}</span>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default NdaNetherlandsContent;
